import React, { Fragment } from 'react';
import { Route, Routes } from 'react-router-dom';
import { WeldListComponent as WeldList } from './list';
import { WeldDetail } from './detail';
import { ErrorBoundary, NotFound } from '@bechtel/client-common';
import { WeldDetailContainer } from './styled';

const Welds = () => {
  return (
    <Fragment>
      <ErrorBoundary>
        <Routes>
          <Route
            path="/"
            element={
              <WeldDetailContainer>
                <WeldDetail />
              </WeldDetailContainer>
            }
          />
          <Route
            path={`/:id`}
            element={
              <WeldDetailContainer>
                <WeldDetail />
              </WeldDetailContainer>
            }
          />
          <Route
            path="*"
            element={
              <WeldDetailContainer>
                <NotFound />
              </WeldDetailContainer>
            }
          />
        </Routes>
      </ErrorBoundary>
      <ErrorBoundary>
        <WeldList />
      </ErrorBoundary>
    </Fragment>
  );
};

export default Welds;
